import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

export { obtenerServicios, Cotizacion, CotizacionConcepto, CotizacionGrupo } from "app/logic/operativa/cotizacion";
import { obtenerFletes as obtenerFletesImport, obtenerServicios, Cotizacion, CotizacionGrupo } from "app/logic/operativa/cotizacion";


/**Obtiene la información de cotización de una guia */
export function obtenerCotizacionDeGuia(guia: models.DocumentacionGuia): Cotizacion {
    const envio = obtenerFletes(guia.Paquetes, guia.Sobre, guia.DistanciaFlete);
    const servicios = obtenerServicios(guia.Importes, {
        EntregaDomicilio: !!guia.Servicios.EntregaDomicilio,
        RecoleccionDomicilio: !!guia.Servicios.RecoleccionDomicilio,
        TipoAcuse: guia.Servicios.Acuse == null ? null : guia.Servicios.Acuse
    });

    return {
        grupos: [envio, servicios],
        descuentoFlete: guia.Importes.ImporteDescuentoFlete,
        flete: guia.Importes.Flete,
        subtotal: guia.Importes.Subtotal,
        iva: guia.Importes.Iva,
        retencionIva: guia.Importes.RetencionIva,
        total: guia.Importes.Total
    };
}

export function obtenerObservacionesDeGuia(guia: models.DocumentacionGuia): string[] {
    var obs1 = guia.Paquetes.map(x => x.Observaciones);
    var obs2 = guia.Sobre.map(x => x.Observaciones);
    var res = obs2.concat(obs1);
    var poliza_text = "";

    if (!guia.SeguroViaje) {
        if ( guia.NumeroPoliza.length <= 0) {
            poliza_text =  "Seguro: Viaja por cuenta y riesgo del cliente"
        } else {
            poliza_text =  "Seguro: Viaja por cuenta y riesgo del cliente, póliza: ".concat(guia.NumeroPoliza);
        }
    }

    if (guia.Paquetes.length > 0 ) {
        res = res.concat(poliza_text)    
    }
    
    return res;
}

function obtenerFletes(paquetes: models.PaqueteDocumentacion[], sobres: models.SobreDocumentacion[], distanciaFlete: number): CotizacionGrupo {
    const cantSobres = sobres.map(x => x.Cantidad).reduce((a, b) => a + b, 0);
    const importeSobres = sobres.map(x => x.Importes!.Flete).reduce((a, b) => a + b, 0);
    const paqs = paquetes.map(x => ({ ...x, Importes: x.Importes! }));
    return obtenerFletesImport(paqs, cantSobres, importeSobres, distanciaFlete);
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guias/logic.tsx